import { Link, type Href } from 'expo-router';
import { type ReactElement } from 'react';

export interface LinkableProps {
  /** When set (and not disabled), renders the child as a real `<a href>` on web. */
  href?: Href;
  disabled?: boolean;
  /** A single element that forwards props (href/role/onPress) — a Pressable/Text. */
  children: ReactElement;
}

/**
 * Wraps a single pressable/text child in an expo-router `<Link>` when `href` is
 * set, so web emits a real `<a href>` (cmd/middle-click, hover URL, open-in-new-tab)
 * while native keeps normal tap navigation. Renders the child bare otherwise.
 *
 * The child must be a host element (`Pressable`/`Text`/`View`) or a `forwardRef`
 * component — `<Link asChild>` forwards a ref to it.
 */
export function Linkable({ href, disabled, children }: LinkableProps) {
  if (href == null || disabled) return children;
  return (
    <Link href={href} asChild>
      {children}
    </Link>
  );
}
